import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Engrenagem from "../../assets/images/icons/icon_settings_header.svg";
import { getParameterization, putParameterization } from "../../store/middleware";

import { Prices } from "./styles";

function Parameterization() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [parameters, setParameters] = useState([]);

  useEffect(() => {
    getParameters();
    // eslint-disable-next-line
  }, []);

  const getParameters = () => {
    dispatch(getParameterization())
      .then((res) => {
        let parameters = res;
        res
          .sort((itemA, itemB) => itemA.id - itemB.id)
          .map((item) => {
            return { ...item, hasChange: false };
          });
        setParameters(parameters);
      })
      .catch((res) => console.log(res));
  };

  const inputChange = (e, index) => {
    const { value, name } = e.target;

    setParameters((state) =>
      state.map((item, i) => (i === index ? { ...item, hasChange: true, [name]: value } : item)),
    );
  };

  const sendParameterChange = async (e) => {
    e.preventDefault();

    parameters
      .filter((item) => item.hasChange)
      .map((item) => {
        const { id, parameterValue } = item;

        dispatch(putParameterization(id, parameterValue))
          .then((res) => {
            let parameters = res;
            parameters
              .sort((item) => item.id)
              .map((item) => {
                return { ...item, hasChange: false };
              });
            getParameters();
          })
          .catch((res) => console.log(res));
      });
  };

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header t={t} title="Parameters" icon={<img src={Engrenagem} alt="Engrenagem" />} typeIcon="custom" />

        <div className="content">
          <Prices>
            <div className="parameters">
              {parameters.length > 0 &&
                parameters.map((item, index) => (
                  <div key={`parameter${index}`} className="items">
                    <div className="inputs">
                      <label htmlFor={`key${index}`}>{t("KEY")}</label>
                      <input value={item.parameterName} disabled name="parameterName" id={`key${index}`} />
                    </div>
                    <div className="inputs">
                      <label htmlFor={`description${index}`}>{t("DESCRIPTION")}</label>
                      <input
                        disabled
                        name="parameterDescription"
                        id={`description${index}`}
                        value={item.parameterDescription}
                      />
                    </div>
                    <div className="inputs">
                      <label htmlFor={`value${index}`}>{t("VALUE")}</label>
                      <input
                        id={`value${index}`}
                        name="parameterValue"
                        value={item.parameterValue}
                        onChange={(e) => inputChange(e, index)}
                      />
                    </div>
                  </div>
                ))}
            </div>

            <div className="button">
              <button className="back" onClick={() => navigate(-1)}>
                <i className="fa fa-angle-left" aria-hidden="true"></i>Back
              </button>
              <button className="save" onClick={sendParameterChange}>
                Save
              </button>
            </div>
          </Prices>
        </div>
      </section>
    </div>
  );
}

export default Parameterization;
